import { moteGradientMap } from '@mote/helpers/constants'
import styled from '@xstyled/styled-components'
import { mediaBreakpointUp } from '../../theme/core/breakpoints'

export interface StyledThemedBackgroundHeaderProps {
  isAuthenticated: boolean
  background: 'classic' | 'mulberry' | 'neutral'
}

export const StyledThemedBackgroundHeader =
  styled.div<StyledThemedBackgroundHeaderProps>(
    {
      position: 'relative',
      width: '100%',
      height: 80,
      [mediaBreakpointUp('md')]: {
        height: 120
      }
    },
    props => ({
      background:
        props.background === 'neutral'
          ? props.theme.colors.grey.l1
          : moteGradientMap[props.background]
    }),
    props =>
      props.isAuthenticated && {
        borderRadius: 0,
        [mediaBreakpointUp('md-lg')]: {
          borderRadius: '1.5rem 0 0',
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            height: '100%',
            left: 0,
            right: 0,
            zIndex: -1,
            backgroundColor: props.theme.colors.grey.l4
          }
        }
      }
  )
